import React from 'react';
import PropTypes from 'prop-types';
import { Grid, Divider } from '@mui/material';
import OfferDecisionFinancedAssetItemComponent from './OfferDecisionFinancedAssetItemComponent';

export const OfferDecisionFinancedAssetsComponent = ({ assets }) => {
  return (
    <Grid container>
      {assets.map((asset, index) => {
        return (
          <Grid key={index} item xs={12}>
            {index !== 0 && <Divider />}
            <OfferDecisionFinancedAssetItemComponent asset={asset} />
          </Grid>
        );
      })}
    </Grid>
  );
};

OfferDecisionFinancedAssetsComponent.propTypes = {
  assets: PropTypes.array
};

export default OfferDecisionFinancedAssetsComponent;
